// extracted by mini-css-extract-plugin
export default {"content-container":"Alv7n","price-container":"Vkq9J"};